<template>
  <!-- 마이페이지 홈 화면에서의 사용자정보 -->
  <div class="user-information-wrap col3" v-if="isMyPageRoot">
    <div class="box-gray">
      <div class="box-inner">
        <div class="grade-icon-wrap">
          <img class="grade-icon" :src="userGradeImgSrc" width="auto" height="64" alt="">
        </div>
        <div class="user-info-wrap">
          <NuxtLink to="/pc/mypage/information" class="link-btn gray200">{{ commonInfo?.userGradeDto?.hcUsrGrdNm }} 등급</NuxtLink>
          <NuxtLink to="/pc/mypage/information">
          <h3 class="user-name multi-ellips mt14">{{ commonInfo?.userGradeDto?.bzcoNm }}</h3>
          </NuxtLink>
        </div>
      </div>
    </div>
    <div class="box-gray">
      <div class="box-inner-top">
        <NuxtLink to="/pc/mypage/hcash/charge" class="link-btn gray200">H캐시</NuxtLink>
        <div class="deal-btn-wrap">
          <NuxtLink to="/pc/mypage/hcash/charge" class="lined-btn txt-hide">충전하기</NuxtLink>
          <NuxtLink to="/pc/mypage/hcash" class="lined-btn txt-hide">거래내역</NuxtLink>
        </div>
      </div>
      <div class="box-inner-bottom">
        <p class="retention h-money">{{ HconCommonUtils.format.expComma(commonInfo?.userHcashDto?.availableHcash) }}<span>원</span></p>
      </div>
    </div>
    <div class="box-gray">
      <div class="box-inner-top">
        <NuxtLink to="/pc/mypage/mileage" class="link-btn gray200">적립금</NuxtLink>
      </div>
      <div class="box-inner-bottom">
        <p class="retention h-money">{{ HconCommonUtils.format.expComma(commonInfo?.userMileageDto?.availableMlg) }}<span>원</span></p>
      </div>
    </div>
  </div>

  <!-- 마이페이지 홈 이외의 화면에서의 사용자정보 -->
  <div class="user-information-wrap" v-if="isMyPageSub">
    <div class="box-gray">
      <div class="box-inner">
        <div class="grade-icon-wrap">
          <img class="grade-icon" :src="userGradeImgSrc" width="40" height="40" alt="">
        </div>
        <div class="user-info-wrap">
          <h3 class="user-name multi-ellips">{{ commonInfo?.userGradeDto?.bzcoNm }}</h3>
        </div>
        <div class="row left-auto gap60">
          <NuxtLink to="/pc/mypage/hcash/charge" class="link-btn gray200">H캐시<span class="count">{{ HconCommonUtils.format.expComma(commonInfo?.userHcashDto?.availableHcash) }}</span> 원</NuxtLink>
          <NuxtLink to="/pc/mypage/mileage" class="link-btn gray200">적립금<span class="count">{{ HconCommonUtils.format.expComma(commonInfo?.userMileageDto?.availableMlg) }}</span> 원</NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import gradeF from '@/assets/images/pc/icon-hcon/grade-F.png';
import gradeG from '@/assets/images/pc/icon-hcon/grade-G.png';
import gradeP from '@/assets/images/pc/icon-hcon/grade-P.png';

const { refreshCnt, commonInfo } = useHeader();

// 마이페이지 홈 상단 사용자 정보 초기 호출 API 목록
onMounted (() => {
  refreshCnt();
});

const route = useRoute();

// 마이페이지 홈 및 마이페이지 하위 페이지 구분
const isMyPageRoot = computed<boolean>(() => {
  return /\/mypage\/?$/.test(route.path);
});

const isMyPageSub = computed<boolean>(() => {
  return /\/mypage\/.+/.test(route.path);
});

// 등급 이미지 
const imageMap: Record<string, string> = {
  FRIENDS: gradeF,
  GOLD: gradeG,
  PLATINUM: gradeP
}

// 사용자등급명에 따른 등급이미지 url 호출
const userGradeImgSrc = computed(() => {
  if(commonInfo.value?.userGradeDto) {
    return imageMap[commonInfo.value.userGradeDto.hcUsrGrdNm]
  }
});

</script>
<style lang="scss" scoped>
@use "@/assets/scss/pc/mypage-hcon.scss" as *;
</style>